import { useEffect, useMemo } from 'react';
import { isEmpty } from 'lodash-es';
import { useGeneralRoutes } from '@namespace/cms';
import {
  getIsExternalUrl,
  getLocalStorageValue,
  LOCAL_STORAGE_KEYS,
  setLocalStorageValue
} from '@namespace/helpers';
import { useLocation } from '@namespace/i18n';

export const useLeaveDepositConfirm = ({
  variant,
  setIsBackButtonClicked,
  setIsMenuClicked,
  setIsShowPopup,
  setRedirectUrl
}) => {
  const { deposit } = useGeneralRoutes();
  const { pathname, search } = useLocation();
  const isDepositPage = useMemo(
    () => pathname === `${deposit}/` && isEmpty(search),
    [pathname, deposit, search]
  );

  const handleGlobalClick = (e) => {
    const { isShowPopupAgain } = getLocalStorageValue(
      LOCAL_STORAGE_KEYS.DEPOSIT_CONFIRM_POPUP_SHOW,
      {
        isShowPopupAgain: true
      }
    );

    let link;
    let isMenuClick;
    let isBackButtonClick;

    if (e.target?.closest) {
      isMenuClick = e.target?.closest(
        '[data-role="bottom-navigation-menu-item-menu"]'
      );
      isBackButtonClick = e.target?.closest(
        '[data-role="page-header-back-button"]'
      );
      link =
        e.target?.closest('a') ||
        e.target?.closest('[data-role="bottom-navigation-menu-item"]');
    }

    if (variant !== 'variant-a' && isShowPopupAgain) {
      if (
        (link && !getIsExternalUrl(link.href)) ||
        isMenuClick ||
        isBackButtonClick
      ) {
        e.preventDefault();
        e.stopPropagation();

        if (isEmpty(search)) {
          setIsShowPopup(true);
          if (variant === 'variant-b') {
            setLocalStorageValue(
              LOCAL_STORAGE_KEYS.DEPOSIT_CONFIRM_POPUP_SHOW,
              {
                isShowPopupAgain: false
              }
            );
          }
        }

        if (isMenuClick) {
          setIsMenuClicked(true);
        } else if (isBackButtonClick) {
          setIsBackButtonClicked(true);
        } else {
          setRedirectUrl(link.pathname || link.dataset.action);
        }
      }
    }
  };

  useEffect(() => {
    if (isDepositPage && variant) {
      document.addEventListener('click', handleGlobalClick, true);
    }

    return () => {
      if (isDepositPage && variant) {
        document.removeEventListener('click', handleGlobalClick, true);
        setRedirectUrl(null);
        setIsMenuClicked(false);
        setIsBackButtonClicked(false);
      }
    };
  }, [isDepositPage]);
};
